// extracted by mini-css-extract-plugin
export default {"main":"ExpiryTable_main__ef88U","nothingText":"ExpiryTable_nothingText__ltoMf","pointer":"ExpiryTable_pointer__ZxhE5"};